import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { getTelegramWebApp } from '../utils/telegram';
import {
  startAnalytics,
  stopAnalytics,
  trackEvent,
  clearSearchFlow,
} from '../utils/analytics';
export default function AnalyticsTracker() {
  const { user } = useUser(),
    { pathname } = useLocation();
  const token = localStorage.getItem('polka_token');
  useEffect(() => {
    if (user?.id && token)
      startAnalytics(user.id, token, !!getTelegramWebApp());
    return () => stopAnalytics();
  }, [user?.id, token]);
  useEffect(() => {
    if (!user?.id) return;
    const item = /^\/item\/(film|series|game|music|book)\/([^/?#]+)$/.exec(
      pathname,
    );
    if (pathname !== '/search' && !item) clearSearchFlow();
    let id = null;
    try {
      if (item) id = decodeURIComponent(item[2]);
    } catch {
      /* Invalid route. */
    }
    trackEvent('page_view', {
      page: item ? '/item' : pathname.split('/').slice(0, 2).join('/') || '/',
      category: item?.[1],
      item_id: id,
    });
  }, [pathname, user?.id]);
  return null;
}
